module.exports = __webpack_public_path__ + "img/cleaning_services-600x450.397de57d.jpg";